export default __webpack_public_path__ + "static/media/PAGE-6@2x.0501aa13.jpg";